/* eslint-disable no-console, no-undef */
import Glide from '../vendors/glide.min';
import { lockVerticalScrollOnHorizontalSwipe } from '../utils/glide-utils';

window.RESET_GLIDE_EVENT = 'reset-glide';
window.resetGlideEvent = new Event(window.RESET_GLIDE_EVENT);

const gridSliders = () => {
  if (document.querySelectorAll('.grid-slider').length === 0) {
    return;
  }
  const sliders = [];
  const breakpointsFullWidth = {
    10000: {
      perView: 1,
      focusAt: 0,
      minWidth: 1,
    },
    0: {
      perView: 1,
      focusAt: 0,
      minWidth: 0,
    },
  };
  const breakpointsHalfWidth = {
    10000: {
      perView: 2,
      focusAt: 0,
      minWidth: 768,
    },
    767: {
      perView: 1,
      focusAt: 0,
      minWidth: 0,
    },
  };
  const breakpointsGridWidth = {
    10000: {
      perView: 4,
      focusAt: 0,
      minWidth: 992,
    },
    991: {
      perView: 3,
      focusAt: 0,
      minWidth: 768,
    },
    767: {
      perView: 3,
      focusAt: 0,
      minWidth: 625,
    },
    624: {
      perView: 2,
      focusAt: 0,
      minWidth: 450,
    },
    449: {
      perView: 1,
      focusAt: 0,
      minWidth: 0,
    },
  };
  let breakpoints = breakpointsGridWidth;
  if (!document.querySelectorAll('.full-width-item').length === 0) {
    breakpoints = breakpointsFullWidth;
  } else if (!document.querySelectorAll('.half-width-item').length === 0) {
    breakpoints = breakpointsHalfWidth;
  } else {
    breakpoints = breakpointsGridWidth;
  }
  const getMinItemsForScreenWidth = () => {
    const { innerWidth } = window;
    let ct = 0;
    Object.keys(breakpoints).forEach((key) => {
      if (breakpoints[key].minWidth <= innerWidth) {
        ct = breakpoints[key].perView;
      }
    });
    return ct;
  };

  const init = (slider) => {
    // console.log('init');
    slider.glideRef = new Glide(slider.element, {
      autoplay: false,
      breakpoints,
      gap: 0,
      perView: 4,
      startAt: 0,
      type: 'carousel',
    });
    slider.glideRef.mount();
    // Prevent iOS Safari from scrolling the page during horizontal swipes.
    if (typeof slider.unlockScroll === 'function') {
      slider.unlockScroll();
    }
    slider.unlockScroll = lockVerticalScrollOnHorizontalSwipe(slider.element);
  };

  const updateGlideEvents = () => {
    sliders.forEach((slider) => {
      const { element, length } = slider;
      const minItems = getMinItemsForScreenWidth();
      const arrows = element.querySelector('.gallery-grid-arrows');
      const isStatic = length <= minItems;

      if (isStatic) {
        element.classList.add('grid-slider--static');
      } else {
        element.classList.remove('grid-slider--static');
      }

      // Need to check what max length should be at any given breakpoint
      // console.log(`${length}/${minItems}`);
      if (length > minItems && !slider.enabled) {
        slider.enabled = true;
        init(slider);
        // Show navigation arrows
        if (arrows) {
          arrows.classList.remove('hidden');
        }
      }
      if (isStatic && slider.enabled) {
        // console.log('destroy');
        slider.enabled = false;
        if (typeof slider.unlockScroll === 'function') {
          slider.unlockScroll();
          slider.unlockScroll = null;
        }
        slider.glideRef.destroy();
        slider.glideRef = null;
        // Hide navigation arrows
        if (arrows) {
          arrows.classList.add('hidden');
        }
      }
      if (slider.glideRef) {
        slider.glideRef.update({ startAt: 0 });
      }
    });
    // console.log(sliders);
  };

  window.addEventListener('resize', () => {
    updateGlideEvents();
  });

  window.addEventListener(window.RESET_GLIDE_EVENT, () => {
    updateGlideEvents();
  });

  [].map.call(document.querySelectorAll('.grid-slider'), (slider) => {
    sliders.push({
      element: slider,
      enabled: false,
      glideRef: null,
      length: slider.querySelectorAll('.grid-slider-item').length,
      unlockScroll: null,
    });
  });
  updateGlideEvents();
};

export default gridSliders;
/* eslint-enable no-console, no-undef */
